import { useForm } from "react-hook-form";
import { Form } from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import getPredikatNilaiKelompok from "../services/getPredikatNilaiKelompok";
import getAsesmenSubkategori from "../services/getAsesmenSubkategori";
import { getUnitKerjaStorage } from "../../../Utils/externalFunctions";
import createAsesmenKelompok from "../services/createAsesmenKelompok";
import getAsesmenKelompokFunction from "../utils/getAsesmenKelompokFunction";
import updateAsesmenKelompok from "../services/updateAsesmenKelompok";
import { FormSubkategoriKelompok } from "../constants/FormSubkategoriList";
import FormAssessmentLayout from "../layouts/FormAssessment";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import { ASESMEN_TYPE } from "../constants";

const FormAssessmentKelompok = ({
  data,
  selectedUnitKerja,
  selectedAssessedBy,
}) => {
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      assessed_by: getUnitKerjaStorage(),
    },
  });
  const navigate = useNavigate();
  const axiosInstance = useAxios();

  const [otherData, setOtherData] = useState({
    predikat: [],
    asesmenSubkategori: [],
  });
  const [pendingSubmit, setPendingSubmit] = useState(false);

  let isMounted = true;
  useEffect(() => {
    const fetchData = () => {
      getPredikatNilaiKelompok(axiosInstance).then((res) =>
        setOtherData((prev) => ({ ...prev, predikat: res.data }))
      );
      getAsesmenSubkategori(axiosInstance).then((res) =>
        setOtherData((prev) => ({ ...prev, asesmenSubkategori: res.data }))
      );
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const asesmenKelompok = getAsesmenKelompokFunction(
      data,
      selectedUnitKerja,
      selectedAssessedBy
    );

    if (asesmenKelompok) {
      let idx = 0;
      FormSubkategoriKelompok.forEach((question) =>
        question.questions.forEach((row) => {
          const predikat = data.asesmenPredikat?.find(
            (asesmenPredikat) =>
              asesmenPredikat?.id ===
              Number(asesmenKelompok.predikats.split(", ")[idx])
          );

          setValue(row.name, predikat?.predikat ?? "");
          idx += 1;
        })
      );
      setValue(
        "kebutuhan_pengembangan",
        asesmenKelompok.kebutuhan_pengembangan ?? ""
      );
    } else {
      let idx = 0;
      FormSubkategoriKelompok.forEach((question) =>
        question.questions.forEach((row) => {
          setValue(row.name, "");
          idx += 1;
        })
      );
      setValue("kebutuhan_pengembangan", "");
    }
  }, [data.asesmenKelompok, data.asesmenPredikat]);

  useEffect(() => {
    setValue("assessed_by", selectedAssessedBy);
  }, [selectedAssessedBy]);

  const submitItem = (formData) => {
    setPendingSubmit(true);
    const asesmenKelompok = getAsesmenKelompokFunction(
      data,
      selectedUnitKerja,
      selectedAssessedBy
    );

    const newData = {
      assessed_by: formData.assessed_by,
      unit_kerja: selectedUnitKerja,
      predikats: [
        // data["1"],
        // data["2"],
        // data["3"],
        (formData["4"] !== "" ? formData["4"] : null) ?? null,
        (formData["5"] !== "" ? formData["5"] : null) ?? null,
        (formData["6"] !== "" ? formData["6"] : null) ?? null,
        (formData["7"] !== "" ? formData["7"] : null) ?? null,
        (formData["8"] !== "" ? formData["8"] : null) ?? null,
        (formData["9"] !== "" ? formData["9"] : null) ?? null,
        (formData["10"] !== "" ? formData["10"] : null) ?? null,
      ],
      kebutuhan_pengembangan: formData.kebutuhan_pengembangan,
    };

    if (asesmenKelompok) {
      updateAsesmenKelompok(axiosInstance, asesmenKelompok.id, newData)
        // .then(() => {
        //   navigate("/dashboard");
        // })
        .finally(() => {
          setPendingSubmit(false);
        });
    } else {
      createAsesmenKelompok(axiosInstance, newData)
        // .then(() => {
        //   navigate("/dashboard");
        // });
    }
  };

  return (
    <Form onSubmit={handleSubmit(submitItem)}>
      <FormAssessmentLayout
        formQuestions={FormSubkategoriKelompok}
        control={control}
        otherData={otherData}
        selectedUnitKerja={selectedUnitKerja}
        pendingSubmit={pendingSubmit}
        type={ASESMEN_TYPE.Kelompok}
        featureDisabled={!FEATURE_FUNCTION_SELECTION.AsesmenKelompok.Update}
      />
    </Form>
  );
};

export default FormAssessmentKelompok;
